import React from "react"
import styled from "styled-components"
import { FaHeart } from 'react-icons/fa'

const FooterWrapper = styled.footer`
    height: 100px;
    background-color: ${({ theme }) => (theme === "light" ? "#393e46" : "#222831")};
    color: #ffffff;
    padding: 40px;
    padding-bottom: 50px;
`

const Footer = ({ theme }: { theme: string }): JSX.Element => {
    return (
        <FooterWrapper theme={theme} className="flex justify-between">
            <span>Sorting Visualizer - Copyright &copy; {new Date().getFullYear()}</span>
            <span>Made with <FaHeart className="inline text-red-600"/> by Vedant</span>
        </FooterWrapper>
    )
}

export default Footer
